<template>
<div class="login-container">
    
    <div class="logo-area">
        <img src="logo.png" style="height:3rem;" alt="CreatorsDost">
    </div>

    <div class="login-card">
        <div class="header-text">
            <h1>Admin Portal</h1>
            <p>Please enter your details to sign in</p>
        </div>

        <div class="form-group">
            <i class='bx bx-envelope'></i>
            <input 
                type="email" 
                placeholder="Admin Email" 
                v-model="login.email"
            >
        </div>

        <div class="form-group">
            <i class='bx bx-lock-alt'></i>
            <input 
                type="password" 
                placeholder="Password" 
                v-model="login.password"
            >
        </div>

        <button class="btn-login" @click="doLogin" :disabled="isLoading">
            <span v-if="!isLoading">Sign In</span>
            <span v-else>Signing in...</span>
            <i class='bx bx-right-arrow-alt'></i>
        </button>

        <div class="error-box" v-if="error">
            <i class='bx bx-error-circle'></i>
            {{ error }}
        </div>
    </div>

    <div class="footer-note">
        Powered by <strong>ABCD Company PVT LTD</strong>
    </div>

</div>
</template>
<script>
import { useToast } from "vue-toastification";
import { adminLoginApi } from "@/apis/adminapis";

export default {
  name: "LoginScreen",

  data() {
    return {
      toast: null,

      isLoading: false,
      error: "",

      login: {
        email: "",
        password: ""
      }
    };
  },

  mounted() {
    this.toast = useToast();
  },

  methods: {
    async doLogin() {
      this.error = "";

      if (!this.login.email || !this.login.password) {
        this.error = "Please enter email and password";
        // this.toast.error("Please enter email and password");
        return;
      }

      this.isLoading = true;

      try {

         const res = await adminLoginApi({
                email: this.login.email,
                password: this.login.password,
            });

        if (res.status) {

            sessionStorage.setItem(
            "ldata",
            JSON.stringify(res.admin)
            );

            // Store token for authenticated APIs
            sessionStorage.setItem(
            "accessToken",
            res.accessToken
            );

          this.$router.push("/");

        } else {

          this.error = res.success || "Invalid credentials";
        }

      } catch (e) {

        this.error = "Something went wrong";
        // this.toast.error("Something went wrong");

      }

      this.isLoading = false;
    }
  }
};
</script>
    <style scoped>
        :root {
            --primary: #2563eb;
            --primary-hover: #EA580C;
            --bg-web: #F1F5F9;
            --text-main: #0F172A;
            --text-muted: #64748B;
            --white: #ffffff;
            --error: #EF4444;
        }

        * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
            font-family: 'Inter', sans-serif;
        }

        body {
            height: 100vh;
            display: flex;
            justify-content: center;
            align-items: center;
            background-color: var(--bg-web);
            /* Subtle geometric background for Web UI */
            background-image: radial-gradient(#cbd5e1 0.5px, transparent 0.5px);
            background-size: 24px 24px;
        }

        .login-container {
            width: 100%;
            max-width: 420px;
            padding: 20px;
        }

        .login-card {
            background: var(--white);
            padding: 45px;
            border-radius: 24px;
            box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.1);
            border: 1px solid rgba(255, 255, 255, 0.7);
        }

        .logo-area {
            text-align: center;
            margin-bottom: 35px;
        }

        .logo-text {
            font-size: 28px;
            font-weight: 600;
            color: var(--text-main);
            letter-spacing: -1px;
        }

        .logo-text span {
            color: var(--primary);
        }

        .header-text {
            text-align: center;
            margin-bottom: 30px;
        }

        .header-text h1 {
            font-size: 22px;
            font-weight: 600;
            color: var(--text-main);
            letter-spacing: -0.5px;
        }

        .header-text p {
            font-size: 14px;
            color: var(--text-muted);
            margin-top: 6px;
            font-weight: 500;
        }

        /* Input Styling */
        .form-group {
            margin-bottom: 20px;
            position: relative;
        }

        .form-group i {
            position: absolute;
            left: 16px;
            top: 50%;
            transform: translateY(-50%);
            color: var(--text-muted);
            font-size: 20px;
            transition: 0.3s;
        }

        .form-group input {
            width: 100%;
            padding: 14px 16px 14px 48px;
            border-radius: 14px;
            border: 1px solid #E2E8F0;
            background: #F8FAFC;
            outline: none;
            font-size: 14px;
            font-weight: 500;
            transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        }

        .form-group input:focus {
            border-color: var(--primary);
            background: var(--white);
            box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.1);
        }

        .form-group input:focus + i {
            color: var(--primary);
        }

        /* Button Styling */
        .btn-login {
            width: 100%;
            padding: 16px;
            background: var(--primary);
            color: white;
            border: none;
            border-radius: 14px;
            font-size: 15px;
            font-weight: 700;
            cursor: pointer;
            transition: all 0.3s;
            box-shadow: 0 10px 15px -3px rgba(37, 99, 235, 0.3);
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 8px;
        }

        .btn-login:hover {
            background: var(--primary);
            transform: translateY(-1px);
            box-shadow: 0 20px 25px -5px rgba(37, 99, 235, 0.4);
        }

        .btn-login:active {
            transform: translateY(0);
        }

        /* Error Messaging */
        .error-box {
            background: #FEF2F2;
            color: var(--error);
            padding: 12px;
            border-radius: 10px;
            font-size: 13px;
            font-weight: 600;
            margin-top: 20px;
            display: flex;
            align-items: center;
            gap: 8px;
            border: 1px solid rgba(239, 68, 68, 0.1);
        }

        .footer-note {
            text-align: center;
            margin-top: 25px;
            font-size: 13px;
            color: var(--text-muted);
            font-weight: 500;
        }

        .footer-note a {
            color: var(--primary);
            text-decoration: none;
            font-weight: 700;
        }

    </style>